import { Component, Input } from '@angular/core';
import { IProduktSelektion, Product, TariffSelectionCardData } from '@mwe/models';
import { TariffSelectionContainerComponent } from '../../tariff/tariff-selection-container/tariff-selection-container.component';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { WizardProductCardComponent } from '../../product-card/wizard-product-card/wizard-product-card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { HeadlineComponent } from '../../headline/headline.component';

@Component({
  selector: 'mwe-selected-products-summary-card',
  templateUrl: './selected-products-summary-card.component.html',
  imports: [TariffSelectionContainerComponent, BasicCardComponent, WizardProductCardComponent, TranslatePipe, HeadlineComponent],
  standalone: true,
})
export class SelectedProductsSummaryCardComponent {
  @Input() products: Product[];
  @Input() selectedTariffs: TariffSelectionCardData[] = [];
  @Input() cardCategoryTitleKeyPrefix?: string = undefined;
  @Input() showTariffDetailsLink = true;
  @Input() showTariffDetails = true;
  @Input() grundpreisLabelOverwrite?: string;
  @Input() productSelection?: IProduktSelektion;
  @Input() isSecureOffer = false;
  @Input() allesSicherTextParams?: { url: string } = undefined;
}
